var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 83,
    viewBox: "0 0 61 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7416 6.61302C54.2214 15.4242 54.2214 29.7118 45.7416 38.5289C37.2618 47.34 23.5054 47.34 15.0259 38.5289C6.54607 29.7115 6.54607 15.4238 15.0259 6.61302C23.5057 -2.20434 37.2621 -2.20434 45.7416 6.61302Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6514 50.4053C55.1741 53.3839 58.2163 58.5986 58.207 64.6182V70.5674C58.207 74.1665 55.6991 77.0994 52.4102 77.6602H52.4082C46.0345 78.7521 38.6252 79.5283 30.3887 79.5283C22.1592 79.5283 14.75 78.7466 8.36719 77.6602H8.36816C5.08328 77.0993 2.57039 74.165 2.57031 70.5674V64.6221C2.57032 58.6009 5.61271 53.3881 10.1367 50.4053C15.7647 54.8166 22.7767 57.4619 30.3945 57.4619C38.012 57.4619 45.0237 54.8165 50.6514 50.4053Z",
    stroke: "#3C3C3C",
    strokeWidth: 5.14123
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/AccountIcon.cb5a2f0319cd19d54d4956579e8cfef7.svg";
export { ForwardRef as ReactComponent };